import csvToJson from "../csvToJson";
import {calculateAge} from "../../util";

function inferTherapieempfehlung(diagnose, patientInfo, pregnancy, therapieConfigurationFile) {
    const therapieConfiguration = csvToJson(therapieConfigurationFile);
    console.log(
        {
            "msg": "inferTherapieempfehlung",
            "component": "therapieempfehlung"
        })
    for (const rule of therapieConfiguration) {
        if (rule['Diag_ID'] === getDiagnoseId(diagnose) && rule['Sex'] === patientInfo.sex && agePatientInRange(rule, patientInfo.birthDate)) {
            if (patientInfo.sex === 'w' && !patientOver60(patientInfo.birthDate)) {
                if (rule['Schwanger'] === pregnancy) {
                    console.log("Medicament with Rule_ID: " + rule['Rule_ID'] + " is fulfilled")
                    console.log(
                        {
                            "msg": "medicament found",
                            "component": "therapieempfehlung",
                            "Rule_ID": rule['Rule_ID'],
                            "rule": rule
                        })
                    return rule
                }
            } else {
                console.log("Medicament with Rule_ID: " + rule['Rule_ID'] + " is fulfilled")
                console.log(
                    {
                        "msg": "medicament found",
                        "component": "therapieempfehlung",
                        "Rule_ID": rule['Rule_ID'],
                        "rule": rule
                    })
                return rule
            }

        }
    }

    console.log({
        "msg": "there was no medicament found for the given information",
        "diagnose": diagnose,
        "patientInfo": patientInfo,
        "pregnancy": pregnancy,
        "component": "therapieempfehlung"
    })

}

function agePatientInRange(rule, patBirthDate) {
    const patientAge = calculateAge(patBirthDate);
    const minAge = parseInt(rule['Alter >=']);
    const maxAge = parseInt(rule['Alter <']);
    return (patientAge >= minAge && patientAge < maxAge)
}

function getDiagnoseId(diagnose) {
    let mapDiagnoseToDiagnoseId = {
        "fokale Epilepsie": "1",
        "genetisch generalisierte Epilepsie": "2",
        "genetisch generalisierte Epilepsie, ausschließlich mit Absencen": "3",
        "unklassifizierte Epilepsie": "4",
        "Widersprüchliche Befunde": "6",
        "Kein Anfall = keine Epilepsie!": "6",
        "Nicht klassifizierbare Episoden": "6",
        "V.a. psychogene, nicht-epileptische Anfälle":"5"
    }
    return mapDiagnoseToDiagnoseId[diagnose]
}

function readMedicamentInfo(medicamentInfo) {
    return csvToJson(medicamentInfo);
}

function patientOver60(patBirthDate) {
    const patientAge = calculateAge(patBirthDate)
    return patientAge >= 60;
}

export default {inferTherapieempfehlung: inferTherapieempfehlung, readMedicamentInfo: readMedicamentInfo}
